module.exports = __webpack_public_path__ + "static/media/microphone.c92f7c6e.svg";